import React, {
  useState,
  useContext,
  useEffect,
  useCallback,
  useRef,
} from "react";
import RoleSelector from "../roleSelector/RoleSelector";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/auth-context";
import { ClinicaContext } from "../../context/clinica-context";
import { useVersionCheck } from "../../context/version-check-context";
import SeletorUnidade from "../seletorUnidade/SeletorUnidade";

import { NotificationsContext } from "../../context/notification-context";
import Dashboard from "@mui/icons-material/Dashboard";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import NotificationsPopover from "./NotificationsPopover/NotificationsPopover";
import MenuNotifications from "./MenuNotifications/MenuNotifications";

import ModalCriarAgendamentoProvisorio from "./ModalCriarAgendamentoProvisorio/ModalCriarAgendamentoProvisorio";
import ModalConfirmarAgendamento from "../../../pages/home/components/modalConfirmarAgendamento/ModalConfirmarAgendamento";

import ModalNotificacoesPermanentes from "./ModalNotificacoesPermanentes/ModalNotificacoesPermanentes";

import "./Navbar.scss";

import { useWebSocketSubscription } from "../../context/websocket-context";
import { useActiveDoctors } from "../../context/active-doctors-context";
import ActiveDoctorsSelector from "./ActiveDoctorsSelector/ActiveDoctorsSelector";

import { useHttpClient } from "../../../shared/hooks/http-hook";
import HelpButton from "../tutorialModal/HelpButton";
import ReportProblema from "../reportProblema/ReportProblema";

//Chat
import ChatIcon from "@mui/icons-material/Chat";
import Badge from "@mui/material/Badge";
import Dialog from "@mui/material/Dialog";
import { useChatContext } from "../../context/chat-context";
import ChatContainer from "../chat/ChatContainer";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import Tooltip from "@mui/material/Tooltip";
import { useContingenciaEfatura } from "../../hooks/contingencia-efatura-hook";

function Navbar({
  title = "Pagina",
  icon = Dashboard,
  paths = [],
  btn = false,
  iconBtn = "",
  medicos,
  avaliacaoDispensada = null,
  onSuccessCriarAgendamentoProvisorio,
  tutorialData,
}) {
  const { sendRequest } = useHttpClient();
  const [listaPresenca, setListaPresenca] = useState([]);
  const [isOnline, setIsOnline] = useState(true);
  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);
  const { hasNewVersion, reloadApp, dismissUpdate } = useVersionCheck();
  const { modoContingenciaAtivo } = useContingenciaEfatura();

  const {
    notifications,
    addNotification,
    removeNotification,
    descartarLocalmente,
    clearAllNotifications,
    fetchNotifications,
  } = useContext(NotificationsContext);

  const navigate = useNavigate();
  const location = useLocation();

  const [modalHistoricoOpen, setModalHistoricoOpen] = useState(false);

  const Icon = icon;
  const BtnIcon = iconBtn;
  const [openNotifications, setOpenNotifications] = useState(false);
  const [anchorElNotifications, setAnchorElNotifications] = useState(null);
  const lastNotificationIdRef = useRef(null);
  const { activeDoctorIds } = useActiveDoctors();

  const notificationSoundRef = useRef(null);

  //Lista de presenca
  const notificationPresencaSoundRef = useRef(null);
  const lastListaPresencaLengthRef = useRef(0);
  const lastPresencaEventIdRef = useRef(null);

  const { medicoId } = useParams();

  // states para os modals agendamentos provisorios
  const [modalCriarAgendamento, setModalCriarAgendamento] = useState({
    open: false,
    clienteId: null,
    medicoId: null,
    notificacaoId: null,
  });

  const [modalConfirmarAgendamento, setModalConfirmarAgendamento] = useState({
    open: false,
    agendamentoId: null,
  });

  //chat
  const chat = useChatContext();
  const [chatOpen, setChatOpen] = useState(false);

  const logout = () => {
    navigate("/");
    auth.logout();
  };

  useEffect(() => {
    if (clinica?.clinica?._id) {
      fetchNotifications(clinica.clinica._id);
    }
  }, [clinica?.clinica?._id, fetchNotifications]);

  useEffect(() => {
    // Create the audio element for notification sound
    const audio = new Audio("/sounds/notification.wav");
    audio.volume = 1; // Set volume to 50%
    notificationSoundRef.current = audio;

    return () => {
      // Clean up if needed
      audio.pause();
      audio.src = "";
    };
  }, []);

  const playNotificationSound = () => {
    if (notificationSoundRef.current) {
      // Reset the audio to the start
      notificationSoundRef.current.pause();
      notificationSoundRef.current.currentTime = 0;

      // Play the sound
      notificationSoundRef.current.play().catch((error) => {
        // Handle any errors (e.g., if browser blocks autoplay)
        console.error("Error playing notification sound:", error);
      });
    }
  };

  //Online, offline message
  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const handleDispensarNotificacao = useCallback(
    async (notificationId) => {
      removeNotification(notificationId, auth.userId);
      if (avaliacaoDispensada) {
        avaliacaoDispensada(notificationId);
      }
    },
    [removeNotification, avaliacaoDispensada],
  );

  const handleClickNotificacao = useCallback(
    async (
      idNotificacao,
      tipo,
      idCliente,
      dados,
      isNotificacaoPermanente = false,
    ) => {
      if (isNotificacaoPermanente === false) {
        removeNotification(idNotificacao, auth.userId);
      } else {
      }

      switch (tipo) {
        case "espera avaliação":
          navigate(`/clientes/${idCliente}-avaliacao`);
          break;
        case "espera observação":
          navigate(`/clientes/${idCliente}-historico`);
          break;
        case "espera consulta":
          navigate(`/clientes/${idCliente}`);
          break;
        case "criou tratamento isolado":
          navigate(`/clientes/${idCliente}-tratamentoIsolado`);
          break;
        case "efetuou avaliação":
          navigate(
            auth.role === "Secretária(o)"
              ? `/orcamentos/new/${dados.avaliacaoId}`
              : `/clientes/${idCliente}-avaliacao`,
          );
          break;
        case "reagendamento":
          if (location.pathname === "/") {
            window.location.reload(); // refresh apenas se estiver na página inicial
          }
          break;

        case "limpezaRealizada":
          // Abrir modal de criar agendamento provisório
          setModalCriarAgendamento({
            open: true,
            clienteId: idCliente,
            medicoId: dados.medicoId,
            notificacaoId: idNotificacao,
          });
          break;
        case "lembreteAgendamentoProvisorio":
          // Abrir modal de gestão de agendamento provisório
          setModalConfirmarAgendamento({
            open: true,
            agendamentoId: dados.agendamentoProvisorio,
          });
          break;
        case "documentoParaImprimir": {
          /* Abre o SUB-SEPARADOR do tipo de documento, e não um fixo.
           *
           * O sufixo do URL é lido pelo `Documentos.js`, que escolhe o
           * separador a partir dele. Mandar tudo para `-prescricao`, como aqui
           * estava, levava quem criou um impresso ou um atestado à lista das
           * prescrições — o documento existia, mas não estava à vista, e
           * parecia que o aviso mentia.
           *
           * Os cinco tipos que o backend grava em `dados.tipoDocumento` têm
           * todos sufixo próprio. O `requisicaoExames` vem em camelCase do
           * servidor e o sufixo é todo minúsculo — é por isso que o mapa existe
           * em vez de se usar o tipo diretamente. */
          const abaPorTipo = {
            prescricao: "prescricao",
            atestado: "atestado",
            impresso: "impresso",
            requisicaoExames: "requisicaoexames",
            consentimento: "consentimento",
          };
          const aba = abaPorTipo[dados?.tipoDocumento] || "documentos";
          navigate(`/clientes/${idCliente}-${aba}`);
          break;
        }
        case "EMPRESA_PARCEIRA_A_EXPIRAR":
          // Navegar para configurações > empresas parceiras
          navigate("/configuracoes/empresasParceiras");
          break;
        default:
          navigate(`/clientes/${idCliente}`);
      }
    },
    [auth.role, navigate, removeNotification],
  );

  const handleCloseNotification = useCallback(() => {
    setOpenNotifications(false);
  }, []);

  const handleOpenNotifications = useCallback((e) => {
    setAnchorElNotifications(e.currentTarget);
    setOpenNotifications(true);
  }, []);

  // Material UI Menu
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const btnOnClickHandler = () => {
    if (btn.link) {
      navigate(btn.link);
    }
  };

  useEffect(() => {
    // Create the audio element for notification sound
    const audio = new Audio("/sounds/presenca.wav");
    audio.volume = 1; // Set volume to 50%
    notificationPresencaSoundRef.current = audio;

    return () => {
      // Clean up if needed
      audio.pause();
      audio.src = "";
    };
  }, []);

  const playNotificationSoundPresenca = () => {
    if (notificationPresencaSoundRef.current) {
      // Reset the audio to the start
      notificationPresencaSoundRef.current.pause();
      notificationPresencaSoundRef.current.currentTime = 0;

      // Play the sound
      notificationPresencaSoundRef.current.play().catch((error) => {
        // Handle any errors (e.g., if browser blocks autoplay)
        console.error("Error playing notification sound:", error);
      });
    }
  };

  useWebSocketSubscription(
    async (parsedSocketData) => {
      /* Um aviso que outra pessoa já resolveu sai do sino.
       *
       * ANTES do guarda do `lastNotificationIdRef` e fora da condição de baixo,
       * de propósito: se o aviso resolvido for o último que recebemos, aquele
       * guarda impedia a remoção e o aviso ficava para sempre no sino.
       *
       * Sem este ramo havia um defeito pior: a resolução chega como `update` e
       * caía no caminho de baixo, que só preenche a mensagem quando a operação
       * é `insert` — a notificação era ACRESCENTADA outra vez, sem texto. */
      if (
        parsedSocketData.tabela === "notificacaos" &&
        parsedSocketData.documento?.resolvida
      ) {
        descartarLocalmente(parsedSocketData.documento._id);
        return;
      }

      if (
        parsedSocketData.tabela === "notificacaos" &&
        parsedSocketData.documento.user.includes(auth.userId) &&
        parsedSocketData.documento._id !== lastNotificationIdRef.current
      ) {
        // Filtrar notificacoes de criação de avaliação, que têm o médico que não está ativo na lista
        // de medicos com que a assistente ou secretária está trabalhando de momento
        if (
          ["Assistente", "Secretária(o)"].includes(auth.role) &&
          parsedSocketData.documento.medicoId && // Make sure medicoId exists in the notification
          !activeDoctorIds.includes(parsedSocketData.documento.medicoId) &&
          /* Os documentos para imprimir NÃO passam por este filtro. Ele existe
             para os avisos de avaliação, que só interessam a quem está a
             trabalhar com aquele médico. Imprimir é de quem está ao balcão,
             seja de que médico for o papel — e com o filtro aplicado o aviso
             chegava pelo websocket só a algumas, mas aparecia a todas ao
             recarregar a página, que é o pior dos dois mundos. */
          parsedSocketData.documento.tipo !== "documentoParaImprimir"
        ) {
          // Skip notifications for doctors that are not active
          return;
        }

        lastNotificationIdRef.current = parsedSocketData.documento._id;
        try {
          const responseData = await fetch(
            `${process.env.REACT_APP_BACKEND_LINK}/api/clientes/${parsedSocketData.documento.cliente}?clinicaId=${clinica.clinica._id}`,
            {
              headers: {
                Authorization: "Bearer " + auth.token,
              },
            },
          ).then((res) => res.json());
          let mensagemNaNotificacao = "";

          if (parsedSocketData.tipoDeOperacao === "insert") {
            mensagemNaNotificacao = parsedSocketData.documento.mensagem;
          }

          const newNotification = {
            cliente: {
              id: parsedSocketData.documento.cliente,
              _id: parsedSocketData.documento.cliente,
              nome: responseData.cliente.nome,
              foto: responseData.cliente.foto,
            },
            tipo: parsedSocketData.documento.tipo,
            id: parsedSocketData.documento._id,
            mensagem: mensagemNaNotificacao,
            dados: parsedSocketData.documento.dados,
            medicoId: parsedSocketData.documento.medicoId,
            medicoNome: parsedSocketData.documento.medicoNome || "Médico",
            created_at: parsedSocketData.documento.created_at,
          };

          addNotification(newNotification);
          playNotificationSound();
        } catch (err) {
          console.error("🔴 Error processing notification:", err);
        }
      }

      if (
        parsedSocketData.tabela === "listapresencas" &&
        parsedSocketData.eventId !== lastPresencaEventIdRef.current &&
        (auth.role === "Médico/Administrador" ||
          auth.role === "Dentista" ||
          auth.role === "Assistente")
      ) {
        lastPresencaEventIdRef.current = parsedSocketData.eventId;

        const fetchListaPresenca = async () => {
          try {
            const responseData = await sendRequest(
              `${process.env.REACT_APP_BACKEND_LINK}/api/listapresenca/${clinica.clinica._id}`,
              "GET",
              null,
              {
                Authorization: "Bearer " + auth.token,
              },
            );

            // ✅ Detectar se houve ADIÇÃO (chegada) ou REMOÇÃO (saída)
            const tamanhoAnterior = listaPresenca.length;
            const tamanhoAtual = responseData.listaPresenca.length;

            if (tamanhoAtual > tamanhoAnterior) {
              // ✅ CHEGADA - algum cliente foi adicionado
              // Identificar qual cliente chegou (o mais recente)
              const updatedAt = new Date(parsedSocketData.documento.updatedAt);

              let clienteQueChegou = null;
              let menorDiferenca = Infinity;

              parsedSocketData.documento.lista.forEach((item) => {
                item.cliente.forEach((cliente) => {
                  const horarioChegada = new Date(cliente.horarioChegada);
                  const diferenca = Math.abs(updatedAt - horarioChegada);

                  // ✅ IMPORTANTE: Só considerar se o horário de chegada é PRÓXIMO do updatedAt
                  // (dentro de 5 segundos, por exemplo)
                  if (diferenca < menorDiferenca && diferenca < 5000) {
                    menorDiferenca = diferenca;
                    clienteQueChegou = cliente.clienteId;
                  }
                });
              });

              if (!clienteQueChegou) {
                setListaPresenca(responseData.listaPresenca);
                lastListaPresencaLengthRef.current =
                  responseData.listaPresenca.length;
                return;
              }

              // Verificar se este cliente tem atendimento
              let todosClienteIds = [];

              if (auth.role === "Assistente") {
                const promises = activeDoctorIds.map(async (doctorId) => {
                  const formData = new FormData();
                  formData.append("medico", doctorId);
                  formData.append("date", new Date().toISOString());

                  if (
                    clinica.clinica.configuracoes.configuracoes.tipoAgendamento
                      .tipo === "Tratamento"
                  ) {
                    formData.append("tipoAgenda", "tratamento");
                  }

                  try {
                    const response = await sendRequest(
                      `${process.env.REACT_APP_BACKEND_LINK}/api/agenda/listaatendimentoclientesids/${clinica.clinica._id}`,
                      "PATCH",
                      formData,
                      {
                        Authorization: "Bearer " + auth.token,
                      },
                    );
                    return response.clienteIds || [];
                  } catch (err) {
                    console.error(
                      `Erro ao buscar clienteIds do médico ${doctorId}:`,
                      err,
                    );
                    return [];
                  }
                });

                const resultados = await Promise.all(promises);
                todosClienteIds = [...new Set(resultados.flat())];
              } else {
                const formData = new FormData();
                formData.append("medico", auth.userId);
                formData.append("date", new Date().toISOString());

                if (
                  clinica.clinica.configuracoes.configuracoes.tipoAgendamento
                    .tipo === "Tratamento"
                ) {
                  formData.append("tipoAgenda", "tratamento");
                }

                const clienteIdsResponse = await sendRequest(
                  `${process.env.REACT_APP_BACKEND_LINK}/api/agenda/listaatendimentoclientesids/${clinica.clinica._id}`,
                  "PATCH",
                  formData,
                  {
                    Authorization: "Bearer " + auth.token,
                  },
                );

                todosClienteIds = clienteIdsResponse.clienteIds || [];
              }

              const temPacienteNaLista =
                todosClienteIds.includes(clienteQueChegou);

              if (temPacienteNaLista) {
                playNotificationSoundPresenca();
              }
            }

            // Atualizar state
            setListaPresenca(responseData.listaPresenca);
            lastListaPresencaLengthRef.current =
              responseData.listaPresenca.length;
          } catch (err) {
            console.error("Erro ao processar lista de presença:", err);
          }
        };

        fetchListaPresenca();
      }
    },
    [auth.userId, auth.token, auth.role, addNotification, activeDoctorIds],
    "NavBar",
  );

  const handleMedicoChange = (e) => {
    const novoMedicoId = e.target.value;

    // Determinar o tipo de agendamento
    const tipoAgendamento =
      clinica.clinica.configuracoes.configuracoes.tipoAgendamento.tipo;
    const isTratamento = tipoAgendamento === "Tratamento";

    // Helper para construir rota
    const getRotaAgendamento = (isViewOnly) => {
      if (isViewOnly) {
        return isTratamento
          ? "agendamentostratamentoviewonly"
          : "agendamentosviewonly";
      }
      return isTratamento ? "agendamentostratamento" : "agendamentos";
    };

    // Gerente: sempre viewOnly
    if (auth.role === "Gerente") {
      navigate(`/${getRotaAgendamento(true)}/${novoMedicoId}`);
      return;
    }

    // Médico/Administrador: edita qualquer agenda se tiver permissão de marcação
    if (auth.role === "Médico/Administrador") {
      const isViewOnly = !auth.perm.includes("c-marc");
      navigate(`/${getRotaAgendamento(isViewOnly)}/${novoMedicoId}`);
      return;
    }

    // Secretária/Assistente: edita apenas médicos associados (se tem permissão)
    if (auth.role === "Secretária(o)" || auth.role === "Assistente") {
      const isMedicoAssociado = auth.usuariosAssociados?.some(
        (u) => u.id === novoMedicoId,
      );
      const isViewOnly = !(isMedicoAssociado && auth.perm.includes("c-marc"));
      navigate(`/${getRotaAgendamento(isViewOnly)}/${novoMedicoId}`);
      return;
    }

    // Dentista: não deveria ter dropdown, mas caso tenha, apenas própria agenda
    if (auth.role === "Dentista" && novoMedicoId === auth.userId) {
      const isViewOnly = !auth.perm.includes("c-marc");
      navigate(`/${getRotaAgendamento(isViewOnly)}/${novoMedicoId}`);
      return;
    }

    // Fallback: viewOnly
    navigate(`/${getRotaAgendamento(true)}/${novoMedicoId}`);
  };

  const handleOpenHistorico = () => {
    setModalHistoricoOpen(true);
  };

  const handleCloseHistorico = () => {
    setModalHistoricoOpen(false);
  };

  return (
    <>
      <ReportProblema />
      <div className="navbar">
        <div className="wrapper">
          <div className="navbar__title">
            <Icon style={{ color: "#175c93", fontSize: "25px" }} />
            <span className="navbar__title__title">{title}</span>
            <SeletorUnidade />
            {tutorialData && <HelpButton tutorialData={tutorialData} />}
            {medicos && (
              <select
                className="navbar__select-medicos"
                onChange={handleMedicoChange}
                value={medicoId}
              >
                {medicos.map((m) => (
                  <option value={m.id} key={m.id}>
                    {m.nomeAbreviado ? m.nomeAbreviado : m.nome}
                  </option>
                ))}
              </select>
            )}
          </div>

          {/* Botão de nova versão */}
          {hasNewVersion && (
            <div className="novaVersaoDisponivel">
              <span>
                Nova Versão disponível:{" "}
                <a
                  onClick={reloadApp}
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                >
                  Recarregar Agora
                </a>
              </span>
              <button
                onClick={dismissUpdate}
                className="btn-dispensar-versao"
                aria-label="Dispensar atualização"
              >
                ✕
              </button>
            </div>
          )}

          {modoContingenciaAtivo && (
            <span className="modoContingenciaAtivoMsgNavbar">
              MODO CONTINGÊNCIA
            </span>
          )}

          {process.env.REACT_APP_AMBIENTE === "teste" ||
            (!isOnline && (
              <div className="mensagensImportantes">
                {/* {process.env.REACT_APP_AMBIENTE === "teste" && (
              <span>AMBIENTE DE TESTE</span>
            )} */}
                <span>{!isOnline && "Sem Conexão à Internet!"}</span>
              </div>
            ))}

          <div className="items">
            {auth.listaRoles.length > 1 && (
              <div className="item">
                <RoleSelector />
              </div>
            )}

            {/* Chat Icon */}
            <div
              className="item"
              style={{ cursor: "pointer" }}
              onClick={() => setChatOpen(true)}
            >
              <IconButton size="large">
                <Badge badgeContent={chat.unreadCount} color="error">
                  <ChatIcon style={{ color: "#1976d2", fontSize: "28px" }} />
                </Badge>
              </IconButton>
            </div>

            {["Assistente", "Secretária(o)"].includes(auth.role) &&
              auth.usuariosAssociados?.length > 1 && (
                <div className="item">
                  <ActiveDoctorsSelector />
                </div>
              )}

            <div className="item" style={{ cursor: "pointer" }}>
              <NotificationsPopover
                nrNotificacoes={notifications.length}
                onClick={handleOpenNotifications}
                anchorEl={anchorElNotifications}
              />
              <MenuNotifications
                anchorEl={anchorElNotifications}
                handleCloseNotification={handleCloseNotification}
                openNotification={openNotifications}
                notificacoes={notifications}
                handleDispensarNotificacao={handleDispensarNotificacao}
                handleClickNotificacao={handleClickNotificacao}
                handleApagarTodasNotificacoes={clearAllNotifications}
                onVerTudo={handleOpenHistorico}
              />
            </div>

            <div className="navbar__item__userInfo">
              <img
                src={
                  auth.image
                    ? `${process.env.REACT_APP_BACKEND_LINK}/${auth.image}`
                    : "/images/fallBackPicture.png"
                }
                alt=""
                className="avatar"
              />
              <div className="navbar__item__userInfo__nomeRole">
                <span className="navbar__item__userInfo__nomeRole__nome">
                  {auth.nomeAbreviado}
                </span>
                <span className="navbar__item__userInfo__nomeRole__role">
                  {auth.role}
                </span>
              </div>
              <KeyboardArrowDownIcon
                className="navbar__dropdownIcon"
                style={{ cursor: "pointer" }}
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              />
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <MenuItem
                  onClick={() => navigate(`/users/${auth.userId}/perfil`)}
                >
                  Perfil
                </MenuItem>
                <MenuItem onClick={logout}>Sair</MenuItem>
              </Menu>
            </div>
          </div>
        </div>
        {paths.length > 0 && (
          <div className="navbar__path__wrapper">
            <div className="navbar__path">
              {paths.map((path, i) =>
                i === 0 ? (
                  <Link to={path.link} key={i}>
                    <span className="navbar__path">{path.nome}</span>
                  </Link>
                ) : (
                  <div className="navbar__path-utility-div" key={i}>
                    <span className="navbar__icon__front">{">"}</span>
                    {i === paths.length - 1 ? (
                      <span className="navbar__path navbar__path__last">
                        {path.nome}
                      </span>
                    ) : (
                      <Link to={path.link}>
                        <span className="navbar__path">{path.nome}</span>
                      </Link>
                    )}
                  </div>
                ),
              )}
            </div>

            {btn && (
              <div className="navbar__buttons">
                <div className="big-btn">
                  <BtnIcon className="big-btn-icon" />
                  <span className="big-btn-text" onClick={btnOnClickHandler}>
                    {btn.text}
                  </span>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {modalCriarAgendamento.open && (
        <ModalCriarAgendamentoProvisorio
          open={modalCriarAgendamento.open}
          onClose={() =>
            setModalCriarAgendamento({
              open: false,
              clienteId: null,
              medicoId: null,
              notificacaoId: null,
            })
          }
          clienteId={modalCriarAgendamento.clienteId}
          medicoId={modalCriarAgendamento.medicoId}
          notificacaoId={modalCriarAgendamento.notificacaoId}
          clinicaId={clinica.clinica._id}
          authToken={auth.token}
          onSuccessCriarAgendamentoProvisorio={
            onSuccessCriarAgendamentoProvisorio
          }
        />
      )}
      {modalConfirmarAgendamento.open && (
        <ModalConfirmarAgendamento
          open={modalConfirmarAgendamento.open}
          onClose={() =>
            setModalConfirmarAgendamento({
              open: false,
              agendamentoId: null,
            })
          }
          agendamentoId={modalConfirmarAgendamento.agendamentoId}
          authToken={auth.token}
          clinicaId={clinica.clinica._id}
          onUpdate={() => {
            // Refresh ou atualização
            window.location.reload();
          }}
        />
      )}

      {modalHistoricoOpen && (
        <ModalNotificacoesPermanentes
          open={modalHistoricoOpen}
          onClose={handleCloseHistorico}
          onClickNotificacao={handleClickNotificacao}
        />
      )}

      {/* Chat Dialog */}
      <Dialog
        open={chatOpen}
        onClose={() => {
          setChatOpen(false);
          chat.clearSelection();
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            height: "600px",
            maxHeight: "80vh",
          },
        }}
      >
        {/* Header do Chat */}
        <Box
          sx={{
            p: 2,
            bgcolor: "primary.main",
            color: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">Chat</Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Tooltip title={chat.soundEnabled ? "Desativar som" : "Ativar som"}>
              <IconButton
                size="small"
                onClick={() => {
                  const newValue = !chat.soundEnabled;
                  chat.toggleSound(newValue);
                  // Atualizar no backend
                  fetch(
                    `${process.env.REACT_APP_BACKEND_LINK}/api/users/notificationsound/${auth.userId}`,
                    {
                      method: "PATCH",
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + auth.token,
                      },
                      body: JSON.stringify({ playNotificationSound: newValue }),
                    },
                  ).catch((err) =>
                    console.error("Erro ao atualizar som:", err),
                  );
                }}
                sx={{ color: "white" }}
              >
                {chat.soundEnabled ? <VolumeUpIcon /> : <VolumeOffIcon />}
              </IconButton>
            </Tooltip>
            <IconButton
              size="small"
              onClick={() => {
                setChatOpen(false);
                chat.clearSelection();
              }}
              sx={{ color: "white" }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>

        {/* Conteúdo do Chat */}
        <Box
          sx={{
            height: "calc(100% - 64px)",
            overflow: "hidden",
          }}
        >
          <ChatContainer embedded />
        </Box>
      </Dialog>
    </>
  );
}

export default Navbar;
